export default {
  large: [

    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                blockModifiers: ['endMargin','alignTop'],
                headerSize: 'large',
                header1: 'Your&nbsp;ready-made marketplace.',
                text1: "<p>Spotin makes it possible for anyone to open a marketplace with no effort.</p><p>Use Spotin's UI to select what brands and retailers to work with, and tailor the product highlights on your shop's first page (if you want) - done.</p><p> Together with Spotin’s on-site features it gives you the power to offer everything from curated highlights, to each and every product variant from partnering sellers.</p>",
                component3: {
                  type: 'animation',
                  data: {
                    loop: true,
                    autoplay: true,
                    blockModifiers: ['bringToFront','350px','mobileOffSetMinus50'],
                    src: "ShopScroll.json",
                  }
                }
              },
            },
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnBlue',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                blockModifiers: ['startMargin','alignCenter'],
                header1: 'Seamlessly embeds into&nbsp;your content',
                text1: '<p>You don’t want to lose traffic, and your visitors don’t want to be redirected somewhere else.</p><p>With all commercial features built as a layer on top of your content you keep your visitors on-site, and your visitors get a more convenient shopping experience that is also aligned with your brand.</p>',
                component2: {
                  type: 'animation',
                  data: {
                    blockModifiers: ['mobileTopMargin','noBottomMargin'],
                    loop: true,
                    autoplay: true,
                    src: "Open_Close_Shop_Desktop.json",
                  }
                },
              }
            },
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnBlue',
        blockModifiers: ['paddingBottom'],
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                blockModifiers: ['endMargin','centerAlignText'],
                header1: 'Just like we added a shop <a onClick="spotinAPI.openShop();" style="text-decoration: underline;">here</a>, you can add one to your content. <a onClick="spotinAPI.openShop();" style="text-decoration: underline;">Have a look</a>, see what it could be like.',
              }
            },
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnOffBlack',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                blockModifiers: ['endMargin','alignCenter'],
                component1: {
                  type: 'animation',
                  data: {
                    blockModifiers: ['350px','mobileBottomMargin'],
                    loop: true,
                    autoplay: true,
                    src: "WavingHand.json",
                  }
                },
                header2: 'Say&nbsp;hello&nbsp;to the&nbsp;full&nbsp;catalogue',
                text2: 'In the shop your readers can access the full catalogue of your partnering sellers. Spotin’s integration towards sellers includes all products, variants, colours, and live updated stock quantities of SKUs. It’s literally like shopping from the seller directly, only it’s via your shop, and you get a commission on every sale.',
              }
            },
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                blockModifiers: ['endMargin','alignCenter'],
                component1: {
                  type: 'animation',
                  data: {
                    loop: true,
                    autoplay: true,
                    src: "ShopReel.json",
                  }
                },
                header3: 'Tailor&nbsp;curated shopping&nbsp;experiences for&nbsp;your&nbsp;readers',
                text3: 'With Spotin it’s easier than ever to design your storefront and build unique shopping experiences. By creating sets of product lists with different templates you can display everything from curated collections to highlighting single products with short feature stories.<br><br>Together with features like customizable menus and hero images you can also choose to add your logo, font and colour scheme - giving your visitors the best possible curated shopping experience.',
              }
            },
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnOffBlack',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                blockModifiers: ['endMargin','alignCenter'],
                header1: 'One&nbsp;line&nbsp;of &#60;code&#62; and you’re&nbsp;up &&nbsp;running',
                text1: 'After creating your account you’ll recieve a script to add to your site. Easily added to your code and  unlocks all the Spotin features.',
                component2: {
                  type: 'animation',
                  data: {
                    blockModifiers: ['mobileTopMargin','noBottomMargin'],
                    loop: true,
                    autoplay: true,
                    src: "OneLineOfCode.json",
                  }
                },
              }
            },
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                blockModifiers: ['endMargin'],
                header1: 'The Shop vs <br>your editorial content',
                text2: 'All our features are built to co-exist, and to create the most friction-free shopping experiences. Like opening any part of the shop from within your content, or embedding commercial features from the shop in your site’s content.',
              }
            },
            bottom: {
              component: 'flex-block',
              data: {
                component2: {
                  type: 'animation',
                  data: {
                    loop: true,
                    autoplay: true,
                    src: "ShopVsEditorial.json",
                  }
                },
              }
            }
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                headerSize: 'large',
                blockModifiers: ['endMargin','centerAlignText'],
                header1: `
                Feature <a onClick="spotinAPI.openShop();" style="text-decoration: underline; color: #0048FF;">your Shop</a> 
                without page reload from anywhere in your content. 
                Like <a href="https://www.spotin.com/shop#/sp?s=1&c=85" style="text-decoration: underline; color: #0048FF;">this category of 🧦</a> 
                or <a href="https://www.spotin.com/shop#/sp?s=1&p=42146&v=570924" style="text-decoration: underline; color: #0048FF;">this 📕 from David Sundin.</a>`,
              }
            },
            bottom: {
              component: 'flex-block',
              data: {
                columns: 3,
                blockModifiers: ['noMargin','centerAlignText','boldText'],
                text2: '(or why not refer to a curated list of products in your shop, within your site content)',
              }
            }
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        blockModifiers: ['centerBottom'],
        sections: [
          {
            full: {
              component: 'html-block',
              data: {
                blockModifiers: ['endMargin'],
                // html: '<spotin-block data-blockid="curated-c09da1c7-bdd5-4766-ae22-1d3198d70c20"></spotin-block>' // Dev
                html: `<spotin-block data-blockid="curated-8986e03a-5264-4d27-908a-d7cd8573f913"></spotin-block>`
              }
            }
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnSand',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                blockModifiers: ['endMargin','alignCenter'],
                header1: 'Drive&nbsp;sales&nbsp;from&nbsp;all your&nbsp;social&nbsp;channels',
                text1: 'With Spotins social sharing features you can promote your shoppable content from anywhere you can add a link. Instagram stories, Bio links, Newsletters, tweets, LinkedIn, Facebook, Pinterest, TikTok, YouTube and more. Instead of monetizing traffic and lose your readers, you can now drive sales and traffic to your own content at the same time.',
                component3: {
                  type: 'animation',
                  data: {
                    blockModifiers: ['bringToFront','350px','mobileOffSetMinus50','mobileTopMargin'],
                    loop: true,
                    autoplay: true,
                    src: "PerfectForSome.json",
                  }
                },
              }
            },
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnOffBlack',
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                // blockModifiers: ['endMargin'],
                header1: 'Shop features',
              }
            },
            bottom: {
              component: 'flex-block',
              data: {
                blockModifiers: ['smallHeader','smallText','bottomMarginOnLastColumn'],
                header1: 'Related&nbsp;sales, seamless&nbsp;and built&nbsp;in',
                text1: 'The shop complements the on-site commerce solutions by enabling customers to discover and buy anything from partnering brands and retailers. From a single product customers can discover everything from the seller (or e.g. author for books) - without loading a new page.',
                header2: 'UI to edit and manage first page',
                text2: 'You can easily create curated lists and selections with use of pre-made templates for your Shop\'s first page by using Spotin\'s UI (see Commerce Manager below).',
                header3: 'Your Picks First',
                text3: 'Spotin allows, not only customers, but also content makers, to highlight their favourites to show the most relevant products to visitors. Editors picks will always be showcased before all other products when browsing the shop.',
              }
            }
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnOffBlack',
        blockModifiers: ['noPaddingTop'],
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                blockModifiers: ['endMargin','smallHeader','smallText'],
                header1: 'Automated product highlights',
                text1: 'Automatically creates data-driven highlighting of products. What\'s selling the most, most popular, or in season.',
                header2: 'All sales in one place',
                text2: 'Since Spotin is working directly with the selling parties we get their full inventories and prices. This also means we also get everything that\'s on sale, in the same place',
                header3: ' ',
                text3: ' ',
              }
            },
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnBlue',
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                // blockModifiers: ['endMargin'],
                header1: 'A&nbsp;ton&nbsp;of&nbsp;features<br>to&nbsp;drive&nbsp;sales',
              }
            },
            bottom: {
              component: 'flex-block',
              data: {
                blockModifiers: ['smallHeader','smallText','bottomMarginOnLastColumn'],
                header1: 'No links, redirects or page (re)loads',
                text1: 'Avoid loading new pages (even site). Convert your visitors to paying customers with a seamless experience from content to commerce.',
                header2: 'One bag and one checkout',
                text2: 'Add products from different sellers, even across different sites, and complete order with a single checkout.',
                header3: 'Payment solutions included',
                text3: 'Apple pay, Google Pay, Visa, Mastercard and the most common cards, and Klarna. We add more payment solutions all the time and configure payment options depending on customer preferences for different markets.',
              }
            },
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnBlue',
        blockModifiers: ['noPaddingTop'],
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                blockModifiers: ['smallHeader','smallText','bottomMarginOnLastColumn'],
                header1: 'International sales',
                text1: 'Reach new markets and new customers with Spotin’s solutions: language configurable/detectable by site or region, automatic handling of seller shipping countries, cross-market VAT information to customers, prices in the right currency from specific seller warehouse, and currency conversion if prices in local currency is missing from seller.',
                header2: 'Site-specific campaigns',
                text2: 'No need for discount codes with site specific campaign prices. Sellers may set specific prices e.g. for specific products or categories for specific sites and time periods with Spotin. This empowers content makers and sellers to work together on site specific campaigns. Spotin automatically keeps track of campaigns and highlight these in the UI.',
                header3: 'Always up to date',
                text3: 'Always everything from selling parties, always the latest, with live-updated stock levels and prices for your market. New drops, sales or something sold out? Spotin always keeps your commerce updated.',
              },
            },
            bottom: {
              component: 'flex-block',
              data: {
                blockModifiers: ['endMargin','smallHeader','smallText'],
                header1: 'Related&nbsp;sales, seamless&nbsp;and built-in',
                text1: 'Sell related products with spots within sellers’ product images, by automatic recommendations, or from discovering more from the seller (or author). Spotin also enables seamless related sales which was previously a strong argument for redirecting customers somewhere else.',
                header2: 'Pre-order and backorder',
                text2: 'Pre-order products before they are released (e.g. print on demand or soon to be released book, or a garment from the a runway image). We also support backorder of products if you do. Spotin also highlights this information to the customer to drive sales and inform users of delayed delivery.',
                header3: 'Branded design (optional)',
                text3: 'We can brand your commerce solution with Spotin so that it fits with your identity. We can add your logo, fonts, color schemes and styles to align and enhance the customer experience with your brand’s identity.',
              }
            }
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnSand',
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                // blockModifiers: ['endMargin'],
                header1: 'Spotin Commerce Manager',
                text2: '<p>The Commerce Manager is where you’ll create and manage all content in your shop, as well as adding shopping features in your site’s content.</p><p>Just like The Shop, the Commerce Manager appears as a layer on top of your site’s content when you login directly on your site.</p>',
                link2: {
                  linkText: 'Know more',
                  route: 'commercemanager',
                },
              }
            },
            bottom: {
              component: 'flex-block',
              data: {
                // blockModifiers: ['endMargin'],
                component2: {
                  type: 'animation',
                  data: {
                    blockModifiers: ['maxWidthHeight800'],
                    loop: true,
                    autoplay: true,
                    src: "ContentManager.json",
                  }
                },
              }
            },
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'blueOnSand',
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                header1: 'Other products & solutions'
              }
            },
            bottom: {
              component: 'Related',
              data: {
                buttons: [
                  {
                    icon: 'arrowUpRight',
                    label: 'Spotin Commerce Manager',
                    blockModifiers: ['alignLabelLeft', 'alignLabelTop'],
                    path: 'commercemanager',
                  },
                  {
                    icon: 'arrowUpRight',
                    label: 'In-content commerce',
                    blockModifiers: ['alignLabelLeft', 'alignLabelTop'],
                    path: 'incontent',
                  },
                  {
                    icon: 'arrowUpRight',
                    label: 'Bag & checkout',
                    blockModifiers: ['alignLabelLeft', 'alignLabelTop'],
                    path: 'checkout',
                  }
                ],
              }
            }
          }
        ]
      },
    },

  ],
};



// WEBPACK FOOTER //
// ./pages/Shop.js